<h2>Nakomelingen</h2>
@for (offspring of offsprings; track offspring.id ) {
    <app-alpaca-offspring-card [alpaca]="offspring"></app-alpaca-offspring-card>
}
